import React, { useState } from "react";
import LoadingImage from "./LoadingImage";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";

import logo from "../../images/Logo/gray_logo.png";
import { COMMON_ALT } from "../../constant";

const LazyImage = ({
  src,
  alt,
  className,
  loadingClassName,
  closeInverted,
  fetchPriority,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`${className} relative`}>
      <LazyLoadImage
        src={src}
        alt={alt}
        onLoad={() => {
          setLoaded(true);
        }}
        fetchpriority={fetchPriority}
        className={`absolute top-0 left-0 ${className}`}
      />
      {!loaded && (
        <>
          <LoadingImage
            commonLoading={true}
            closeInverted={closeInverted}
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center ${className} ${loadingClassName} !max-w-none`}
          />

          <img
            src={logo}
            className="absolute absolute-center w-[100px]"
            alt={COMMON_ALT}
          />
        </>
      )}
    </div>
  );
};

export default React.memo(LazyImage);
